import { getModule } from 'vuex-module-decorators';

import { SessionAdmin } from '@/models/session-admin';

import { StoreSingleton } from '.';
import SessionStore from './session.module';

export const sessionStore = getModule<SessionStore<SessionAdmin>>(SessionStore, StoreSingleton.getInstance());
